module.exports = __webpack_public_path__ + "static/media/ad-1.1161c4c8.jpg";